import jsPDF from "jspdf";
import "jspdf-autotable";

import { BLACK_RGB, GREEN_RGB, GOLD_RGB, WHITE_RGB, PAGE_HEIGHT, PAGE_WIDTH } from "./constants";

const calculateHeight = (canvas, scale) =>
    canvas.height * (PAGE_WIDTH / canvas.width) * scale;

class PDF extends jsPDF {
    constructor({ orgName, reportingPeriod, whiteLogoImg, colorLogoImg }) {
        super({ compress: true });
        this.yCoord = 0;
        this.pageNum = 1;
        this.orgName = orgName;
        this.reportingPeriod = reportingPeriod;
        this.whiteLogoImg = whiteLogoImg;
        this.colorLogoImg = colorLogoImg;
    }

    addCanvas = function (id, scale = 1, rotation) {
        try {
            let canvas;
            let elementOnScreen = document.querySelector(`#${id}`);

            if (elementOnScreen?.height) {
                canvas = elementOnScreen;
            } else {
                canvas = document.querySelector(`.element-to-print #${id}`);
            }

            if (!canvas) {
                this.addCenteredText("No data available", BLACK_RGB, 20);
                return;
            }
            const canvasImage = canvas.toDataURL("image/png");
            const imgWidth = scale * PAGE_WIDTH;
            const imgHeight = calculateHeight(canvas, scale);
            const margin = ((1 - scale) * PAGE_WIDTH) / 2;

            this.addImage(
                canvasImage,
                "PNG",
                margin,
                this.yCoord,
                imgWidth,
                imgHeight,
                undefined,
                undefined,
                rotation
            );
            this.yCoord += imgHeight;
        } catch (err) {
            console.error(`Error adding ${id}`);
            console.error(err);
        }
    };

    addText = function (text, color, size, xPos, yPos, autoMargin = true) {
        this.setTextColor(...color);
        this.setFontSize(size);
        if (autoMargin) {
            this.yCoord += size * 0.2 + 6;
        }

        this.text(text, xPos, yPos || this.yCoord, { align: "center" });
    };

    addCenteredText = function (text, color, size, autoMargin = true, yPos) {
        this.addText(text, color, size, PAGE_WIDTH / 2, yPos, autoMargin);
    };

    addQuestionText = function (...props) {
        this.setFont("helvetica", "normal");
        this.addCenteredText(...props);
        this.setFont("helvetica", "bold");
    };

    addHeader = async function (height = 36,subtitle="GHG emissions") {
        this.setFillColor(...GREEN_RGB);
        this.rect(0, 0, PAGE_WIDTH, height, "F");

        this.addImage(this.whiteLogoImg, "PNG", PAGE_WIDTH - 60, 6, 50, 8);

        this.setTextColor(...WHITE_RGB);
        this.setFontSize(30);
        this.text(this.orgName, 10, 15);

        this.setFontSize(16);
        this.setFont("helvetica", "normal");
        this.setTextColor(...GOLD_RGB);
        this.text(subtitle, 10, 22);
        this.setFont("helvetica", "bold");

        this.setTextColor(...WHITE_RGB);
        this.setFontSize(12);
        // this.text(this.reportingPeriod, 10, 28);
        this.yCoord += height;
    };

    addFooter = async function (pageNum) {
        this.addImage(this.colorLogoImg, "PNG", 10, PAGE_HEIGHT - 12, 18, 3);
        this.addText(
            String(pageNum),
            BLACK_RGB,
            10,
            PAGE_WIDTH - 12,
            PAGE_HEIGHT - 10,
            false
        );
    };

    addNewPage = async function (addContent) {
        this.addPage();
        this.yCoord = 0;
        await this.addHeader();
        await this.addFooter(this.pageNum++);
        await addContent();
    };


}

export default PDF;
